module.exports = __webpack_public_path__ + "img/yxqn-QRCode-v2.13fb7118.jpg";